import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { changeQueryInput } from 'SearchAllApp/state/search-all-params/search-all-params.actions';
import { getQueryInput } from 'SearchAllApp/state/search-all.selectors';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
function SearchAllInputComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 6);
    i0.ɵɵelementEnd();
} }
function SearchAllInputComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function SearchAllInputComponent_Conditional_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clearInput()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 8);
    i0.ɵɵelementEnd();
} }
/**
 *
 * SearchAllInputComponent.
 *
 * This component is the search box to filter securities with query string.
 */
export class SearchAllInputComponent {
    constructor(store) {
        this.store = store;
        this.query = '';
        this.searchSubject = new Subject();
        this.mapStateToComponent = (state) => {
            this.query = getQueryInput(state);
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnInit() {
        this.searchSubject.pipe(debounceTime(200)).subscribe((searchValue) => {
            this.changeQueryInput(searchValue);
        });
    }
    ngOnDestroy() {
        this.searchSubject.complete();
        this.storeSubscription.unsubscribe();
    }
    queryChange() {
        this.searchSubject.next(this.query);
    }
    clearInput() {
        this.query = '';
        this.changeQueryInput(this.query);
    }
    /**
     * Dispatches `changeQueryInput` to set the new `queryInput` value
     * @param queryInput: Query string.
     */
    changeQueryInput(queryInput) {
        this.store.dispatch(changeQueryInput({ queryInput }));
    }
}
SearchAllInputComponent.ɵfac = function SearchAllInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchAllInputComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
SearchAllInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchAllInputComponent, selectors: [["ycn-search-all-input"]], standalone: false, decls: 6, vars: 2, consts: [[1, "input-group"], [1, "input-group", "field-input-group"], ["placeholder", "Search", 1, "form-control", "field-input", 3, "ngModelChange", "ngModel"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], ["ycnTooltip", "", "tooltipPlacement", "bottom", "tooltipTitle", "Clear The Field", 1, "btn", "btn-transparent", "btn-clear", "ng-scope"], ["ycnIcon", "", "name", "icon-search"], ["ycnTooltip", "", "tooltipPlacement", "bottom", "tooltipTitle", "Clear The Field", 1, "btn", "btn-transparent", "btn-clear", "ng-scope", 3, "click"], ["ycnIcon", "", "name", "icon-close"]], template: function SearchAllInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2);
        i0.ɵɵtwoWayListener("ngModelChange", function SearchAllInputComponent_Template_input_ngModelChange_2_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.query, $event) || (ctx.query = $event); return $event; });
        i0.ɵɵlistener("ngModelChange", function SearchAllInputComponent_Template_input_ngModelChange_2_listener() { return ctx.queryChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵconditionalCreate(4, SearchAllInputComponent_Conditional_4_Template, 2, 0, "div", 4)(5, SearchAllInputComponent_Conditional_5_Template, 2, 0, "button", 5);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtwoWayProperty("ngModel", ctx.query);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.query.length === 0 ? 4 : 5);
    } }, dependencies: [i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.TooltipDirective, i4.IconDirective], encapsulation: 2 });
